
import {
    computed,
    defineComponent,
} from 'vue';
import { ArgoPgTimezoneNames, useTzSelectorQuery } from 'types/db';

const TimezoneSelector = defineComponent({
    props: {
        value: { type: String, required: false, default: () => null },
    },
    emits: [ 'input' ],
    setup () {
        const { result, loading } = useTzSelectorQuery();
        const items = computed(() => result.value?.argo_pg_timezone_names || []);

        return {
            formatName: (x: ArgoPgTimezoneNames) => (x.name || '').replace(/_/muig, ' '),
            items,
            loading,
        };
    },
});

export default TimezoneSelector;
